import React from "react";
import "../Assets/css/index.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackVector from "../Assets/Img/BackVector.svg";

// Settings sections
import NotificationsSettings from "../ProfileSetting/NotificationsSettings";
import AccountSettings from "../ProfileSetting/AccountSettings";
import PrivacyVisibilitySettings from "../ProfileSetting/PrivacyVisibilitySettings";
import PaymentBillingSettings from "../ProfileSetting/PaymentBillingSettings";
import LanguageRegionSettings from "../ProfileSetting/LanguageRegionSettings";
import SupportFeedbackSettings from "../ProfileSetting/SupportFeedbackSettings";
import PaymentMethods from "../ProfileSetting/PaymentMethods";
import TransactionHistory from "./TransactionHistory";
import SubscriptionPlans from "./SubscriptionPlans";

const SettingsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("userType");

  const getSectionTitle = () => {
    const section = location?.state?.section;
    const sectionMap = {
      "account-preferences": "Account Settings",
      "Privacy & Visibility": "Privacy & Visibility",
      "Support & Feedback": "Support & Feedback",
      "Payment & Billing": "Payment & Billing",
      "Language & Region": "Language & Region",
      "payment-methods": "Payment Methods",
      "transaction-hisotry": "Transaction History",
      subscription: "Subscription Plans",
      notifications: "Notifications",
    };
    return sectionMap[section] || "Settings";
  };

  const renderSectionContent = () => {
    const section = location?.state?.section || "";

    switch (section) {
      case "notifications":
        return <NotificationsSettings />;
      case "Privacy & Visibility":
        return <PrivacyVisibilitySettings />;
      case "Payment & Billing":
        return <PaymentBillingSettings />;
      case "payment-methods":
        return <PaymentMethods />;
      case "transaction-hisotry":
        return <TransactionHistory />;
      case "subscription":
        return <SubscriptionPlans />;
      case "Support & Feedback":
        return <SupportFeedbackSettings />;
      case "Language & Region":
        return <LanguageRegionSettings />;
      case "account-preferences":
      default:
        return <AccountSettings />;
    }
  };

  return (
    <>
      <button
        className="navback-button"
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate("/dashboard"); // fallback route
          }
        }}
      >
        <img src={BackVector} alt="back" className="back-vactor" />
        {getSectionTitle()}
      </button>

      <div className="settings-page">{renderSectionContent()}</div>
    </>
  );
};

export default SettingsPage;
